import '@theme/jquery';
import '@theme/slick';

const $ = window.jQuery;
console.log("product-carousel");

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.blocksHTML = this.querySelectorAll('[data-blockId]');
    this.carousels = this.querySelectorAll('.products-list');
    this.tabs = this.querySelectorAll('.tabs__tab');
    this.blocks = [];
  }

  connectedCallback() {
    this.init()
    console.log(this.carousels);
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', (evt) => {

        if (!this.blocks[i].isActive) {
          this.querySelector(`[data-tabBlockId="${this.blocks[i].id}"].arrow-prev`).click();
          setTimeout(() => {
            this.blocks[i].isActive = true;
            this.querySelector(`[data-tabBlockId="${this.blocks[i].id}"].arrow-next`).click();
          }, 300);
        }

        setTimeout(() => {
          const id = this.blocks[i].id;
          this.querySelector(`#products-list--${id}`).style.opacity = 1;
        }, 600);
      })
    })
  }

  init() {
    for (let i = 0; i < this.blocksHTML.length; i++) {
      const el = this.blocksHTML[i];
      const id = el.getAttribute("data-blockId");
      const carousel = {
        element: `#products-list--${el.getAttribute("data-blockId")}`,
        infinite: Boolean(parseInt(el.getAttribute('data-infinite'))),
        autoplay: Boolean(parseInt(el.getAttribute('data-autoplay'))),
        autoplaySpeed: parseInt(el.getAttribute('data-autoplaySpeed')) * 1000,
        desktopProducts: parseInt(el.getAttribute('data-desktopProducts')),
        mobileProducts: parseInt(el.getAttribute('data-mobileProducts')),
      }
      console.log(carousel)

      this.blocks.push({ id: id, isActive: i === 0 ? true : false });

      $(carousel.element).slick({
        lazyLoad: 'ondemand',
        speed: 100,
        infinite: carousel.infinite,
        autoplay: carousel.autoplay,
        autoplaySpeed: carousel.autoplaySpeed,
        slidesToShow: carousel.desktopProducts,
        slidesToScroll: 1,
        cssEase: 'linear',
        draggable: false,
        prevArrow: $(`[data-tabBlockId="${id}"].arrow-prev`),
        nextArrow: $(`[data-tabBlockId="${id}"].arrow-next`),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: carousel.desktopProducts - 1,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: carousel.mobileProducts,
              slidesToScroll: 1
            }
          }
        ]
      });

      if (i === 0) {
        setTimeout(() => {
          this.querySelector(`#products-list--${id}`).style.opacity = 1;
        }, 500);
      }
    }
  }
}

customElements.define("product-carousel", ProductCarousel);